/* Lapoche cart rewards: free shipping bar + auto-added free gift with colour picker. */
(function () {
  'use strict';
  if (window.lpRewardsLoaded) return;
  window.lpRewardsLoaded = true;

  var GIFT_PROP = '_lp_gift';
  var REMOVED_KEY = 'lpGiftRemoved';
  var busy = false;
  var lastCart = null;
  var selectedVariant = null;

  function rate() {
    var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    return r && !isNaN(r) ? r : 1;
  }

  function formatMoney(cents, format) {
    var parts = (cents / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    return (format || '${{amount}}').replace(/\{\{\s*\w+\s*\}\}/, amount.replace(/\.00$/, ''));
  }

  function cartRoute() {
    return (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
  }

  function isGiftLine(item) {
    return item.properties && item.properties[GIFT_PROP];
  }

  function totalSpend(cart) {
    var total = cart.total_price;
    cart.items.forEach(function (item) {
      if (isGiftLine(item)) total -= item.final_line_price;
    });
    return Math.max(0, total);
  }

  // Share of the order taken off by order-level discount codes (e.g. WELCOME10) applied in the cart.
  function orderDiscountRatio(cart) {
    var off = 0;
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      off += d.total_allocated_amount || 0;
    });
    var base = cart.items_subtotal_price || 0;
    return base > 0 ? Math.min(1, off / base) : 0;
  }

  // Turn "amount still needed after the discount" into "amount to add at full price".
  function toFullPrice(cents, ratio) {
    return ratio < 1 ? Math.ceil(cents / (1 - ratio)) : cents;
  }

  /* ---------- Free shipping bar ---------- */

  function renderBar(cart) {
    var bars = document.querySelectorAll('[data-lp-rewards]');
    Array.prototype.forEach.call(bars, function (bar) {
      var fmt = bar.dataset.moneyFormat;
      var tier1 = Math.round(parseFloat(bar.dataset.tier1) * 100 * rate());
      var s = totalSpend(cart);
      var pct = Math.min(100, (s / tier1) * 100);
      bar.querySelector('[data-lp-rewards-fill]').style.width = pct + '%';
      var mark = bar.querySelector('[data-lp-rewards-mark="1"]');
      if (mark) mark.classList.toggle('is-reached', s >= tier1);
      var msg = s < tier1
        ? bar.dataset.msgTier1.replace('[amount]', '<strong>' + formatMoney(toFullPrice(tier1 - s, orderDiscountRatio(cart)), fmt) + '</strong>')
        : bar.dataset.msgDone;
      bar.querySelector('[data-lp-rewards-message]').innerHTML = msg;
    });
  }

  /* ---------- Gift picker ---------- */

  function picker() {
    return document.querySelector('[data-lp-gift]');
  }

  function qualifyingIds(el) {
    var ids = {};
    (el.dataset.qualifyIds || '').split(',').forEach(function (id) {
      if (id) ids[id] = true;
    });
    return ids;
  }

  function qualifyingSpend(cart, el) {
    var ids = qualifyingIds(el);
    var total = 0;
    cart.items.forEach(function (item) {
      if (!isGiftLine(item) && ids[String(item.product_id)]) total += item.final_line_price;
    });
    // Count the new collection spend after any discount code, so 10% off can drop it under the threshold.
    return Math.floor(total * (1 - orderDiscountRatio(cart)));
  }

  function giftLines(cart) {
    return cart.items.filter(isGiftLine);
  }

  function removedByCustomer() {
    try { return sessionStorage.getItem(REMOVED_KEY) === '1'; } catch (e) { return false; }
  }

  function setRemoved(on) {
    try {
      if (on) sessionStorage.setItem(REMOVED_KEY, '1');
      else sessionStorage.removeItem(REMOVED_KEY);
    } catch (e) {}
  }

  function defaultVariant(el) {
    if (selectedVariant && el.querySelector('[data-lp-gift-option][data-variant-id="' + selectedVariant + '"]:not([disabled])')) return selectedVariant;
    var first = el.querySelector('[data-lp-gift-option]:not([disabled])');
    return first ? first.dataset.variantId : null;
  }

  function setState(el, state) {
    el.dataset.state = state;
    el.hidden = state === 'hidden';
  }

  function selectOption(el, variantId) {
    selectedVariant = String(variantId);
    Array.prototype.forEach.call(el.querySelectorAll('[data-lp-gift-option]'), function (btn) {
      var on = btn.dataset.variantId === selectedVariant;
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var label = el.querySelector('[data-lp-gift-selected]');
    var chosen = el.querySelector('[data-lp-gift-option][data-variant-id="' + selectedVariant + '"]');
    if (label && chosen) label.textContent = chosen.dataset.colour;
  }

  function renderPicker(cart) {
    var el = picker();
    if (!el) return;
    var fmt = el.dataset.moneyFormat;
    var threshold = Math.round(parseFloat(el.dataset.threshold) * 100 * rate());
    var msgEl = el.querySelector('[data-lp-gift-message]');
    var fillEl = el.querySelector('[data-lp-gift-fill]');

    // Empty cart (or nothing from the new collection yet): lead with the offer itself.
    if (!cart.item_count || qualifyingSpend(cart, el) === 0) {
      setState(el, 'locked');
      if (fillEl) fillEl.style.width = '0%';
      msgEl.innerHTML = (el.dataset.msgEmpty || el.dataset.msgLocked).replace('[amount]', '<strong>' + formatMoney(threshold, fmt) + '</strong>');
      return;
    }

    var spend = qualifyingSpend(cart, el);
    var lines = giftLines(cart);
    var msg = el.querySelector('[data-lp-gift-message]');
    var fill = el.querySelector('[data-lp-gift-fill]');
    if (fill) fill.style.width = Math.min(100, (spend / threshold) * 100) + '%';

    if (spend < threshold) {
      setState(el, 'locked');
      msg.innerHTML = el.dataset.msgLocked.replace('[amount]', '<strong>' + formatMoney(toFullPrice(threshold - spend, orderDiscountRatio(cart)), fmt) + '</strong>');
      return;
    }

    if (lines.length) {
      setState(el, 'added');
      var colour = '';
      var opt = el.querySelector('[data-lp-gift-option][data-variant-id="' + lines[0].variant_id + '"]');
      if (opt) colour = opt.dataset.colour;
      msg.innerHTML = el.dataset.msgAdded.replace('[colour]', colour);
      selectOption(el, lines[0].variant_id);
    } else {
      setState(el, 'unlocked');
      msg.innerHTML = el.dataset.msgUnlocked;
      var dv = defaultVariant(el);
      if (dv) selectOption(el, dv);
    }
  }

  function post(path, body) {
    return fetch(cartRoute() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function refresh() {
    return fetch(cartRoute() + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      });
  }

  function removeLines(lines) {
    var updates = {};
    lines.forEach(function (l) { updates[l.key] = 0; });
    return post('/update.js', { updates: updates });
  }

  function addGift(el, variantId) {
    if (busy || !lastCart) return;
    busy = true;
    el.classList.add('is-loading');
    var props = {};
    props[GIFT_PROP] = 'true';
    props['Gift'] = el.dataset.lineLabel || 'Free gift';
    var existing = giftLines(lastCart);
    var step = existing.length ? removeLines(existing) : Promise.resolve();
    step
      .then(function () { return post('/add.js', { items: [{ id: Number(variantId), quantity: 1, properties: props }] }); })
      .then(refresh)
      .catch(function () {})
      .then(function () { busy = false; el.classList.remove('is-loading'); });
  }

  // Auto-add the gift at the threshold, keep it to one, and remove it if the customer drops below.
  function syncGift(cart) {
    var el = picker();
    if (!el || busy) return;
    var threshold = Math.round(parseFloat(el.dataset.threshold) * 100 * rate());
    var spend = qualifyingSpend(cart, el);
    var lines = giftLines(cart);

    if (spend < threshold) {
      setRemoved(false);
      if (lines.length) {
        busy = true;
        removeLines(lines).then(refresh).catch(function () {}).then(function () { busy = false; });
      }
      return;
    }

    if (!lines.length) {
      if (!removedByCustomer()) {
        var dv = defaultVariant(el);
        if (dv) addGift(el, dv);
      }
      return;
    }

    if (lines.length > 1 || lines[0].quantity > 1) {
      var updates = {};
      lines.forEach(function (l, i) { updates[l.key] = i === 0 ? 1 : 0; });
      busy = true;
      post('/update.js', { updates: updates }).then(refresh).catch(function () {}).then(function () { busy = false; });
    }
  }

  // If the gift disappears while the customer still qualifies, they removed it on purpose:
  // don't force it back in (they can re-add it from the picker).
  function detectManualRemoval(prev, next) {
    if (!prev || busy) return;
    var el = picker();
    if (!el) return;
    if (!giftLines(prev).length || giftLines(next).length) return;
    var threshold = Math.round(parseFloat(el.dataset.threshold) * 100 * rate());
    if (qualifyingSpend(next, el) >= threshold) setRemoved(true);
  }

  function handle(cart) {
    if (!cart || !cart.items) return;
    detectManualRemoval(lastCart, cart);
    lastCart = cart;
    renderBar(cart);
    renderPicker(cart);
    syncGift(cart);
  }

  document.addEventListener('click', function (e) {
    var el = picker();
    if (!el) return;
    var opt = e.target.closest && e.target.closest('[data-lp-gift-option]');
    if (opt && el.contains(opt)) {
      e.preventDefault();
      if (opt.disabled) return;
      selectOption(el, opt.dataset.variantId);
      // Tapping a colour puts that colour in the cart straight away (swaps if one is already there).
      if (el.dataset.state === 'added' || el.dataset.state === 'unlocked') {
        setRemoved(false);
        addGift(el, opt.dataset.variantId);
      }
      return;
    }
    var add = e.target.closest && e.target.closest('[data-lp-gift-add]');
    if (add && el.contains(add)) {
      e.preventDefault();
      setRemoved(false);
      if (selectedVariant) addGift(el, selectedVariant);
    }
  });

  document.addEventListener('theme:cart:change', function (e) {
    handle(e.detail && e.detail.cart);
  });

  document.addEventListener('theme:drawer:open', function () {
    if (lastCart) { renderBar(lastCart); renderPicker(lastCart); }
  }, true);

  fetch(cartRoute() + '.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(handle)
    .catch(function () {});
})();